/**
 * !!! AUTOGENERATED, DO NOT MODIFY !!!
 *
 * This file is generated by dashboard/script/remote_lookup/generate_remote_lookup_schemas.rb
 * Because the generation script depends on rails, generation is run manually and the file is checked in.
 * Please do not edit manually.
 *
 * To regenerate, run:
 *   yarn remote-lookup:update-generated-schemas
 *
 * @owner @Appboy/messaging-experience
 */

import { z } from "zod";
import { common } from "../common";

// Our zod-to-typescript generation tooling demands an export that matches the module name.
export const tagRemoteLookupSchema = z.any();

export const tagRemoteLookupIdSchema = common.objectId;

export const tagRemoteLookupItemSchema = z.object({ id: common.objectId, name: z.string(), archived: z.boolean() });

export const tagRemoteLookupFiltersSchema = z.object({ include_archived: z.boolean().nullable().optional() });

export const tagRemoteLookupValidators = {
  id: tagRemoteLookupIdSchema,
  item: tagRemoteLookupItemSchema,
  filters: tagRemoteLookupFiltersSchema,
};

/* rails_test_output_hash: 8b4325eafcc2e5962f6aa5d104288c2d */
